import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How to think of your business logic as data",
  "description": "",
  "published": "2017-08-11T00:00:00.000Z",
  "redirect_from": ["/blog/business-logic-data/swizec/7746"],
  "categories": "Learning, Technical",
  "hero": "./img/wikipedia-commons-c-c5-Fdedit.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`I'll never forget this lesson I learned from a friend in 6th or 7th grade.`}</p>
    <p>{`We were building our own Windows clone. In `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Turbo_Pascal"
      }}>{`Turbo Pascal`}</a>{`, running in `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/DOS"
      }}>{`DOS`}</a>{`, using a `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Text-based_user_interface"
      }}>{`textual user interface`}</a>{` because we didn't know how to do graphics.`}</p>
    <p>{`If you're too young to know about textual user interfaces, they looked like this:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "720px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/65145555e3826fc7f97f0d9d71923c62/37523/wikipedia-commons-c-c5-Fdedit.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "55.60538116591929%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'222\\'%20viewBox=\\'0%200%20400%20222\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20111v111h3l2-2-1-2c-2%200-2-12-2-107V4l1%20106a2206%202206%200%20002%20105c0-2%201-2%20195-2a1593%201593%200%2001198%205h-2l-1%202c0%202%201%202%203%202h3V0h-6v18H277v-3l-1-3-1%203%201%203h-94v-3l-1-3-1%203%201%203H5V9c0-9%200-9-2-9H0v111m55%200v84h285V27h-69a585%20585%200%2000-69%202l-1%204v-5c1-1-32-1-72-1H55v84m2%200v81l1-80a760%20760%200%2001-1-1m279-80l1%2081a2083%202083%200%20001-1%20483%20483%200%2000-2-80M180%2045h-2l-3%201%201%201%201%202v2l1-2%201-2%201%203v3h150v-9h-75l-75%201M76%20133v40h34c33%200%2034%200%2034-2l-1-2-2%202-31%201H79V93h62v2c0%202%201%203%202%203l1-3v-3H76v41m159-30v4h40v-9h-40v5m95%201c0%202-1%202-17%202-17%200-18%200-18%202s1%202%2020%202h20v-4c0-4%200-4-2-4s-3%201-3%202m0%2027v2h-17c-17%200-18%200-18%202s1%202%2020%202h20v-4c0-5%200-5-2-5s-3%201-3%203m-15%2026v3h-10c-9%200-10%200-10%202s1%202%2020%202h20v-4c0-5%200-5-2-5s-3%201-3%203%200%202-6%202c-7%200-7%200-7-3l1-1h1l-2-2c-2%200-2%201-2%203m-233%204l1%201-1%202-1%203c-5%201%203%202%2029%202h30v-3c0-2%200-2%201-1h2c1-2%201-3-1-3l-2-1-30-1-28%201m46%2030\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/65145555e3826fc7f97f0d9d71923c62/ca0a1/wikipedia-commons-c-c5-Fdedit.webp 223w", "/static/65145555e3826fc7f97f0d9d71923c62/75680/wikipedia-commons-c-c5-Fdedit.webp 445w", "/static/65145555e3826fc7f97f0d9d71923c62/bc514/wikipedia-commons-c-c5-Fdedit.webp 720w"],
              "sizes": "(max-width: 720px) 100vw, 720px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/65145555e3826fc7f97f0d9d71923c62/e92b6/wikipedia-commons-c-c5-Fdedit.png 223w", "/static/65145555e3826fc7f97f0d9d71923c62/e66bf/wikipedia-commons-c-c5-Fdedit.png 445w", "/static/65145555e3826fc7f97f0d9d71923c62/37523/wikipedia-commons-c-c5-Fdedit.png 720w"],
              "sizes": "(max-width: 720px) 100vw, 720px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/65145555e3826fc7f97f0d9d71923c62/37523/wikipedia-commons-c-c5-Fdedit.png",
              "alt": "wikipedia commons c c5 Fdedit",
              "title": "wikipedia commons c c5 Fdedit",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`It's got windows, buttons, a mouse cursor, and everything else you'd want in a modern user interface. Except graphics. It's all made with ASCII characters.`}</p>
    <p>{`I used to know the ASCII table by heart by back then 🤓`}</p>
    <p>{`Now, when I say `}<em parentName="p">{`we`}</em>{` were building a new Windows, I don't mean working together on a single project. We didn't know how to do that. There was no Git or CVS or SVN back then. At least not that we knew of. The best we could do back then was to use diskettes to borrow each other's code.`}</p>
    <p>{`Oh, we also didn't know about putting code in multiple files, so that was fun.`}</p>
    <p>{`Anyway, the lesson he taught me about business logic being data came when we were both implementing our top row navigation. Like a menu, but for your whole system.`}</p>
    <p>{`Oh yes, we built dropdown menus and everything. It's amazing what a 13 year old with infinite free time can build in a few months.`}</p>
    <h2 {...{
      "id": "avoid-encoding-business-logic-in-the-shape-of-your-program"
    }}>{`Avoid encoding business logic in the shape of your program`}</h2>
    <p>{`Let's say you have 6 items. `}<inlineCode parentName="p">{`File`}</inlineCode>{`, `}<inlineCode parentName="p">{`Edit`}</inlineCode>{`, `}<inlineCode parentName="p">{`Format`}</inlineCode>{`, `}<inlineCode parentName="p">{`View`}</inlineCode>{`, `}<inlineCode parentName="p">{`Window`}</inlineCode>{`, and `}<inlineCode parentName="p">{`Help`}</inlineCode>{`. That's what iA Writer has.`}</p>
    <p>{`Now let's say you want to have a user action that goes through these items. My system used `}<inlineCode parentName="p">{`left`}</inlineCode>{` and `}<inlineCode parentName="p">{`right`}</inlineCode>{` arrow keys, my friend liked `}<inlineCode parentName="p">{`j`}</inlineCode>{` and `}<inlineCode parentName="p">{`k`}</inlineCode>{`, while MacOS relies on mouse alone.`}</p>
    <p>{`You could build navigation like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`onLeftKeyPress() {
    if (currentMenu === "File") {
        goTo("Help")
    }else if (currentMenu === "Edit") {
        goTo("File")
    }else if (currentMenu === "Format") {
        goTo("Edit")
    }else if (currentMenu === "View") {
        goTo("Format")
    }else if (currentMenu === "Window") {
        goTo("View")
    }else if (currentMenu === "Help") {
        goTo("Window")
    }
}

onRightKeyPress() {
    if (currentMenu === "File") {
        goTo("Edit")
    }else if (currentMenu === "Edit") {
        goTo("Format")
    }else if (currentMenu === "Format") {
        goTo("View")
    }else if (currentMenu === "View") {
        goTo("Window")
    }else if (currentMenu === "Window") {
        goTo("Help")
    }else if (currentMenu === "Help") {
        goTo("File")
    }
}
`}</code></pre>
    <p>{`Nothing wrong with that. It's readable, gets the job done, everything's perfect. You congratulate yourself on an engineering problem well solved.`}</p>
    <p>{`Then the PM comes in and says, `}<em parentName="p">{`"We've been running tests, and this sequence doesn't really work. Let's change the order.”`}</em></p>
    <p>{`Uh-oh.`}</p>
    <p><em parentName="p">{`"Oh, and we want different apps to have different menus."`}</em></p>
    <p>{`💩`}</p>
    <p>{`Now you have to rewrite that whole logic for every app. Every time the PM decides to change the order. That's not fun at all!`}</p>
    <p>{`So here's what you can do instead.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`items = ["File", "Edit", "Format", "View", "Window", "Help"]
currentItem = 0

onLeftKeyPress() {
    currentItem -= 1;
    if (currentItem < 0) currentItem = items.length-1;
    goTo(items[currentItem]);
}
onRightKeyPress() {
    currentItem += 1;
    if (currentItem >= items.length) currentItem = 0;
    goTo(items[currentItem]);
}
`}</code></pre>
    <p>{`Array of options, pointer to current selection, move pointer when user does something. Now we're talking!`}</p>
    <p>{`With this approach, your system is flexible. You can change ordering, add elements, remove elements, even have different lists for different apps or users. It's great.`}</p>
    <p>{`No difficult refactoring every time your PM changes their mind, just a data change.`}</p>
    <h2 {...{
      "id": "but-swizec-nobody-builds-keyboard-menus-anymore"
    }}>{`But Swizec, nobody builds keyboard menus anymore!`}</h2>
    <p>{`That's true! People don't use keyboards as much as they used to. My whole thing above is pointless when a user can directly tap or click whatever they want.`}</p>
    <p>{`But we still live in a world of sequental flows. More than ever, things are designed as user flows that go backwards or forwards. Onboarding flows are a good example.`}</p>
    <p>{`Screen1: "Hai", Screen2: "Our app does X", Screen3: "Sign up", Screen4: "Gives us your phone number", Screen5: "Credit card maybe?", Screen6: "Do The Thing"`}</p>
    <p>{`I simplify, but many apps have that flow.`}</p>
    <p>{`You can build it as a hard-coded sequence of steps where each step must know who to call next. When your PM experiments, you're in for a world of heavy refactoring.`}</p>
    <p>{`I had fun like that just this week. Not my fault even! Others on the team decided to build it the not-data way, and now we all suffer. I'm sure they will learn their lesson soon :)`}</p>
    <h2 {...{
      "id": "but-swiz-my-flow-has-branches-and-shit"
    }}>{`But Swiz, my flow has branches and shit`}</h2>
    <p>{`So?`}</p>
    <p>{`You're going to go into your super fancy logic and insert a bunch of if statements all the time?`}</p>
    <p>{`if goNext and currentScreen is 'phone' and userSubscribed and…`}</p>
    <p>{`Fuck.That.`}</p>
    <p>{`Here's how you do it:`}</p>
    <pre><code parentName="pre" {...{}}>{`[() => userSubscribed ? <CreditCard /> : <DoTheThing />, ...]
`}</code></pre>
    <p>{`Put functions in your previous/next logic! Core logic stays simple, end result for user is a complex tree of options.`}</p>
    <p>{`That can get tricky too, I know. But you know what always works? Tree traversal. You can model your flow as a tree and build a simple walker that goes into different branches of the tree based on stuff. Perhaps based on functions in the tree nodes themselves.`}</p>
    <p>{`😉`}</p>
    <p>{`Save time. Make business logic your data. If a Turing machine can do it, so can your app.`}</p>
    <p>{`Happy hacking.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      